module.exports = __webpack_public_path__ + "img/badge-most-proposals-keyvue-pink.f2121e6f.png";